/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import conditionIsFlat from '../helpers/conditionIsFlat.js';
import getUnitType from '../helpers/getUnitType.js';

const SurfHeight = ({
  min,
  max,
  units,
  plus = false
}) => {
  const isFlat = conditionIsFlat(min, max, units);
  const className = classNames({
    'quiver-surf-height': true,
    'quiver-surf-height--flat': isFlat
  });

  if (isFlat) {
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, "Flat");
  }

  const range = min === max ? max : `${min}-${max}`;
  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, range, /*#__PURE__*/React.createElement("sup", null, getUnitType(units)), plus ? '+' : '');
};

SurfHeight.defaultProps = {
  min: 0,
  max: 0,
  units: '',
  plus: false
};

export default SurfHeight;
//# sourceMappingURL=SurfHeight.js.map
